import PropTypes from "prop-types";
import { COLORS } from "../constants";

export function HorizontalBarChart({ data, colors, onBarClick }) {
  const palette = colors || COLORS;
  const maxVal = Math.max(...data.map(d => d.value), 1);
  const barHeight = 28;

  return (
    <div
      style={{
        width: "100%",
        maxHeight: 280,
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: 6,
        padding: "8px 0",
        scrollbarWidth: "thin",
      }}
    >
      {data.map((item, i) => {
        const widthPct = Math.max(20, (item.value / maxVal) * 100);
        const color = palette[i % palette.length];
        return (
          <div
            key={item.name}
            role={onBarClick ? "button" : undefined}
            tabIndex={onBarClick ? 0 : undefined}
            onClick={() => onBarClick?.(item)}
            onKeyDown={e => {
              if (onBarClick && (e.key === "Enter" || e.key === " ")) {
                e.preventDefault();
                onBarClick(item);
              }
            }}
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              gap: 10,
              cursor: onBarClick ? "pointer" : "default",
            }}
          >
            <span
              style={{
                width: 110,
                textAlign: "right",
                fontSize: "0.75rem",
                fontWeight: 500,
                color: "#9ca3af",
                flexShrink: 0,
              }}
            >
              {item.name}
            </span>
            <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
              <div
                style={{
                  width: `${widthPct}%`,
                  height: barHeight,
                  background: `linear-gradient(90deg, ${color}, ${color}cc)`,
                  borderRadius: 6,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "width 0.8s ease-out",
                  boxShadow: `0 2px 8px ${color}33`,
                }}
              >
                <span style={{ fontSize: "0.72rem", fontWeight: 700, color: "#fff" }}>{item.value}</span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

HorizontalBarChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, value: PropTypes.number })).isRequired,
  colors: PropTypes.array,
  onBarClick: PropTypes.func,
};

export default HorizontalBarChart;
